<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <!--- AGRUPAMIENTO POR TX -->

   <div v-if="tipoAgrupamiento === 1"  class="cambiarTratamientoNuevoClass mt-2">
     <b-row class="leterSize">
       <b-col class="ml-5 bold">
         <p>Cambiar Tratamiento</p>
       </b-col>
       <b-col class=" mr-5 text-end">
         <em  class="plusEdicion_svg"
              style=" width: 17px; padding-right: 2px; cursor: pointer"
              v-b-tooltip.hover.top.v-light
              title="agregar Tratamiento"
              @click="agregarCambiarTratamiento()"/>
         <em class="trash_svg"
             style=" width: 17px; padding-right: 2px; cursor: pointer"
             v-b-tooltip.hover.top.v-light
             title="Eliminar registro"
             @click="eliminarTratamientoTodo()"/>
       </b-col>
     </b-row>
     <b-row class="leterSize m-0 p-0 bold" style="margin: 3px;">
       <b-col class="leterSize p-0 columnas-col" style="border-right: #ECECEC 1px solid;">
         <div>
           <p>Tratamiento</p>
         </div>
       </b-col>
       <b-col cols="2" class="leterSize bordeTable text-left p-0 pl-1 d-flex align-items-center mt-1">Padecimiento</b-col>
       <b-col class="leterSize bordeTable p-0 text-center columnas-col mt-1">Cantidad Tratamiento</b-col>
       <b-col class="leterSize bordeTable p-0 text-center columnas-col mt-1">Precio unitario</b-col>
       <b-col class="leterSize bordeTable p-0 text-center columnas-col mt-1" >Acciones</b-col>
     </b-row>
     <div class="mt-2" v-for="(tx, index) in listaTratamientosCambiar" :key="'initx-'+index">
       <b-row class="m-0">
         <b-col class="leterSize p-0 columnas-col">
                  <span>
                  {{index+1}}.
                </span>
           <v-select
               class="ml-1"
               style="width: 100%"
               placeholder="Selecciona un tratamiento"
               label="nombre"
               :options="listaTratamientosCatalogo"
               :reduce="(variable) => variable.idTratamiento"
               id="idTratamiento"
               v-model="tx.idTratamiento"
               @input="obtenerTratamientoCambiar(tx.idTratamiento, index)"
           ><span slot="no-options">No hay datos disponibles</span>
           </v-select>
         </b-col>
         <b-col class="leterSize p-0 columnas-col">
           <v-select
               class="ml-1"
               style="width: 100%"
               placeholder="Selecciona un padecimiento"
               label="nombre"
               :options="listaPadecimientoCatalogo"
               :reduce="(variable) => variable.idPadecimento"
               v-model="tx.idPadecimiento"
               id="idPadecimento"
           ><span slot="no-options">No hay datos disponibles</span>
           </v-select>
         </b-col>
         <b-col class="leterSize p-0 columnas-col">
              <span class="leterSize">
                           <b-form-input
                               type="number"
                               min="1"
                               max="100"
                               v-model="tx.cantidad"
                               @paste.prevent
                               @keydown.prevent
                               class="leterSize"
                           ></b-form-input>
              </span>
         </b-col>
         <b-col class="leterSize p-0 columnas-col">
           <span class="leterSize">{{ tx.precioUnitario | monedaEntero }} </span>
         </b-col>
         <b-col class="leterSize p-0 columnas-col">
           <em class="trash_svg"
               style=" width: 17px; padding-right: 2px; cursor: pointer"
               v-b-tooltip.hover.top.v-light
               title="Eliminar registro"
               @click="eliminarTratamientoCambiar(index, ind1, ind2)"/>
         </b-col>
       </b-row>
     </div>
     <div class="text-center leterSize mt-3  " style="color: #D3540D"><p>Podrás revisar el descuento plan y promo en la presentación</p></div>
   </div>
  <!--- AGRUPAMIENTO POR OD -->
   <div v-else class="cambiarTratamientoNuevoClass mt-2">
     <b-row class="leterSize">

     </b-row>
  </div>
</div>
</template>

<script>
export default {
  name: "EdicionPtiCambiarTratamiento",
  props: {
    tipoAgrupamiento:Number,
    listaTratamientosCatalogo:Array,
    listaPadecimientoCatalogo:Array,
    padecimientoOriginal:Object
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
   listaTratamientosCambiar:[]
  }),
  watch: {
    listaTratamientosCambiar() {
      this.$emit("listatratamientosCambiados", this.listaTratamientosCambiar);
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    agregarCambiarTratamiento(){
      let nuevoTx = {
        "idTratamiento":null,
        "idPadecimiento":null,
        "idDiente":this.padecimientoOriginal.idDiente,
        "estatus": 3,
        "idPtiTratamientoAnterior": this.padecimientoOriginal.idPtiTratamiento,
        "cantidad": 1,
        "nombreTratamiento": null,
        "numeroDiente": this.padecimientoOriginal.numeroDiente,
        "precioUnitario": null
      }
      this.listaTratamientosCambiar.push(nuevoTx);
    },
    obtenerTratamientoCambiar(tratamiento,index){
      if(tratamiento !== null) {
        let objetoEncontrado = this.listaTratamientosCatalogo.find(objeto => objeto.idTratamiento === tratamiento);
        this.listaTratamientosCambiar[index].precioUnitario = objetoEncontrado.precio;
        this.listaTratamientosCambiar[index].nombreTratamiento = objetoEncontrado.nombre;
      }else{
        this.listaTratamientosCambiar[index].precioUnitario = null;
        this.listaTratamientosCambiar[index].precioUnitario.cantidad = 1;
        this.listaTratamientosCambiar[index].nombreTratamiento = null;
      }
    },
    eliminarTratamientoCambiar(index){
      this.listaTratamientosCambiar.splice(index, 1);
    },
    eliminarTratamientoTodo(){
      this.padecimientoOriginal.estatus = 0;
      this.listaTratamientosCambiar = [];
      this.$emit('desactivarApartado', false);
    }
  }
}
</script>

<style scoped>
.leterSize{
  font-size: 10px !important;
  color: #4F4F4F;
}
.bordeTable{
  border-bottom: #ECECEC 1px solid;
}
.columnas-col {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cambiarTratamientoNuevoClass{
  border: 2px solid #D6E7F3 !important;
  padding: 20px !important;
  border-radius: 15px !important;
}
</style>
